import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:frame-load', (event) => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  }
}